import {Routes, RouterModule} from "@angular/router";
import { PublicComponent } from './layouts/public/public.component';
import { AdminComponent } from './layouts/admin/admin.component';

import { PUBLIC_ROUTES } from './constants/public.routes';
import { ADMIN_ROUTES } from "./constants/admin.routes";


import {AdminGuard} from "./_guards/admin.guard";

const appRoutes: Routes = [
  { path: '', component: PublicComponent, children:  PUBLIC_ROUTES},
  { path: '', component: AdminComponent, canActivate: [AdminGuard], children: ADMIN_ROUTES },
  { path: '**', redirectTo: 'error/404' }
];

export const routing = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/app.routing.ts